module.exports = __webpack_public_path__ + "media/images/countrysquared/pw-fae3190a5ff1638b96f6df661f0ef42d.svg";